import React from "react";
import { Box } from "@mui/material";
import SummaryInfoBox from "./SummaryInfoBox";
import NewsguardSummaryInfoBox from "./NewsguardSummaryInfoBox";

const SummaryInfo = ({ data, whoIsData, sx }) => {
  const registrantState = whoIsData?.registrantState?.toUpperCase();
  const registrantCountry = whoIsData?.registrantCountry?.toUpperCase();

  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr)" }}
      gap={2}
      width="100%"
      sx={sx}
    >
      <Box>
        {data?.score ? (
          <NewsguardSummaryInfoBox score={data.score} />
        ) : (
          <NewsguardSummaryInfoBox />
        )}
      </Box>

      <Box>
        {data?.mediaBiasRating ? (
          <SummaryInfoBox header="Media Bias" content={data.mediaBiasRating} />
        ) : (
          <SummaryInfoBox content="Media bias rating unavailable" />
        )}
      </Box>

      {data && (data.charityNavigatorScore || data.charityNavigatorRating) && (
        <Box>
          <SummaryInfoBox
            header="Charity Navigator Rating"
            content={`${data.charityNavigatorScore}%` || "Rating not available"}
          />
        </Box>
      )}

      {registrantState && registrantCountry && (
        <Box>
          <SummaryInfoBox
            header="Registrant Location"
            content={`${registrantState}, ${registrantCountry}`}
          />
        </Box>
      )}
    </Box>
  );
};

export default SummaryInfo;
